export default __webpack_public_path__ + "static/media/4.b8df5e29.pdf";